import classNames from 'classnames';
import styles from './SelectedFilter.module.scss';

export interface SelectedFilterProps {
	className?: string;
	id: string;
	text: string;
	removeFilterText: string;
	onElementRemoved: () => void;
}

export const SelectedFilter = ({ className, id, text, removeFilterText, onElementRemoved }: SelectedFilterProps): JSX.Element => {
	return (
		<span role="alert" className={classNames(className, styles.SelectedFilter, 'alert filter')} id={id}>
			{text}
			<button type="button" className="close" aria-label={removeFilterText + ': ' + text} onClick={onElementRemoved}>
				<span aria-hidden="true">&times;</span>
			</button>
		</span>
	);
};
